import React from 'react'
import { Box, Link } from '@mui/material'
import { getTranslationKey } from '@/src/utils/header/headerUtils'

export interface NavLink {
    label: string
    href: string
    labelKey?: string
    icon?: React.ReactNode
    isActive?: boolean
}

interface HeaderNavigationProps {
    navLinks: NavLink[]
    variant: 'flyin' | 'cleartrip'
    getNavIcon?: (label: string) => React.ReactNode
    t: (key: string) => string
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({ navLinks, variant, getNavIcon, t }) => {
    if (variant === 'cleartrip') {
        return (
            <Box component="nav" sx={{ display: 'flex', gap: 3 }}>
                {navLinks.map(link => (
                    <Box
                        key={link.label}
                        component="div"
                        onClick={e => {
                            e.preventDefault()
                            window.location.href = link.href
                        }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: 14,
                            fontWeight: 500,
                            color: link.isActive ? 'link.main' : 'text.secondary',
                            transition: 'color 0.2s',
                            pb: 0.5,
                            cursor: 'pointer'
                        }}
                    >
                        {getNavIcon && getNavIcon(link.label)}
                    </Box>
                ))}
            </Box>
        )
    }

    return (
        <Box component="nav" sx={{ display: 'flex', gap: 2.5 }}>
            {navLinks.map((link, index) => (
                <Link
                    key={link.label}
                    href={link.href}
                    underline="none"
                    sx={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#1a2a3a',
                        '&:hover': { color: '#194E91' },
                        transition: 'color 0.2s',
                        px: 0.7,
                        display: {
                            xs: index < 2 ? 'block' : 'none',
                            sm: index < 2 ? 'block' : 'none',
                            md: 'block'
                        }
                    }}
                >
                    {t(getTranslationKey(link.label, link.labelKey))}
                </Link>
            ))}
        </Box>
    )
}

export { HeaderNavigation }
export type { HeaderNavigationProps }
